import { render, staticRenderFns } from "./AddFactoryUser.vue?vue&type=template&id=ec2803e6&scoped=true"
import script from "./AddFactoryUser.vue?vue&type=script&lang=js"
export * from "./AddFactoryUser.vue?vue&type=script&lang=js"
import style0 from "./AddFactoryUser.vue?vue&type=style&index=0&id=ec2803e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2803e6",
  null
  
)

export default component.exports